import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
    faFile,
    faFileAudio,
    faFileCode,
    faFileCsv,
    faFileExcel,
    faFileImage,
    faFileLines,
    faFilePdf,
    faFilePowerpoint,
    faFileVideo,
    faFileWord,
    faFileZipper,
    faTrash,
} from '@fortawesome/free-solid-svg-icons';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import prettyBytes from 'pretty-bytes';

@Component({
    selector: 'ell-file-icon',
    standalone: true,
    imports: [CommonModule, NgbDropdownModule, FontAwesomeModule],
    templateUrl: './file-icon.component.html',
    styleUrl: './file-icon.component.scss'
})
export class FileIconComponent {
    prettyBytes = prettyBytes;
    faTrash = faTrash;

    confirmDelete = false;

    @Input()
    allowDelete = false;

    @Input()
    file?: File;

    @Output()
    download = new EventEmitter<File>();

    @Output()
    delete = new EventEmitter<File>();

    get icon() {
        switch (this.file?.name.replace(/^.*\./, '').toLowerCase()) {
            case 'ods':
            case 'xls':
            case 'xlsx':
                return faFileExcel;

            case 'doc':
            case 'docx':
            case 'odt':
                return faFileWord;

            case 'txt':
                return faFileLines;

            case 'csv':
                return faFileCsv;

            case 'html':
            case 'json':
            case 'xml':
                return faFileCode;

            case 'bmp':
            case 'gif':
            case 'heic':
            case 'jpeg':
            case 'jpg':
            case 'png':
            case 'svg':
            case 'tiff':
                return faFileImage;

            case 'odp':
            case 'ppt':
            case 'pptx':
                return faFilePowerpoint;

            case 'aac':
            case 'm4a':
            case 'mp3':
            case 'ogg':
            case 'wav':
                return faFileAudio;

            case 'pdf':
                return faFilePdf;

            case 'avi':
            case 'm4v':
            case 'mov':
            case 'mp4':
            case 'mpeg':
            case 'mpg':
                return faFileVideo;

            case '7z':
            case 'bz2':
            case 'gz':
            case 'rar':
            case 'tar':
            case 'tgz':
            case 'tlz':
            case 'txz':
            case 'xz':
            case 'zip':
                return faFileZipper;

            default:
                return faFile;
        }
    }
}
